import gql from 'graphql-tag'

import { pageInfoData } from './common'
import { AuthenticationUserFragment } from './user'
import { companyOfficesResult } from './company'

export const standardJobResult = gql`
	fragment standardJobResult on Job {
		__typename
		id
		slug
		description
		title
		expiryDate
		contractType
		seniorityLevel
		jobType
		locationType
		featuredImage
		videoUrl
		applyJobExternalUrl
		company {
			__typename
			id
			logoPath
			hasCover
			hasLogo
			name
			slug
			description
			coverPath
			featuredVideo
			industry {
				__typename
				id
				key
			}
		}
		_TeamToJobCollection {edges{node{team{
			__typename
			id
			name
			slug
			description
			hasCover
			coverPath
			teamMemberCollection {edges{node{
				id
				user {
					id
					profileCollection {edges{node{
						id
						firstName
						lastName
					}}}
				}
			}}}}}}
		}
		teamLeader
		jobSalary {
			id
			__typename
			currency
			amountMin
			amountMax
			rate
		}
		benefits
		_JobToCustomSkillsCollection {edges{node{customSkills{
			__typename
			id
			key
			title
		}}}}
		_JobToCompanyOfficesCollection{edges{
			node{
				A
				B
					companyOffices{...companyOfficesResult}
			}
		}}
		# locations {
		# 	__typename
		# 	id
		# 	location {
		# 		__typename
		# 		id
		# 		name
		# 		region2
		# 	}
		# }
		
jobApplicantCollection {edges{node{
			__typename
			id}}
		}
		# checkLoggedUserApplication
	}
	${companyOfficesResult}
`

export const jobConnectionData = gql`
	fragment jobConnectionData on Job {
	
				...standardJobResult
		
		
	}
	${standardJobResult}
	${pageInfoData}
`
export const jobApplicantsConnectionData = gql`
	fragment jobApplicantsConnectionData on JobApplicantConnection {
		edges {
			node {
				user {
					...AuthenticationUser
				}
				createdAt
			}
			cursor
		}
		pageInfo {
			...pageInfoData
		}
	}
	${AuthenticationUserFragment}
	${pageInfoData}
`
// export const jobApplicantsData = gql`
// 	fragment jobApplicantsData on JobApplicant {
// 		edges {
// 			node {
// 				user {
// 					...AuthenticationUser
// 				}
// 				createdAt
// 			}
// 			cursor
// 		}
// 		pageInfo {
// 			...pageInfoData
// 		}
// 	}
// 	${AuthenticationUserFragment}
// 	${pageInfoData}
// `
